import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // removeChild errors from external scripts - suppress and retry
    if (error?.message?.includes("removeChild") || error?.message?.includes("insertBefore") || error?.message?.includes("not a child")) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress removeChild errors from external DOM manipulation
    if (error?.message?.includes("removeChild") || error?.message?.includes("insertBefore") || error?.message?.includes("not a child")) {
      console.warn("[ErrorBoundary] Suppressed external DOM error:", error.message);
      return;
    }
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
    // Report to Jarvis (fire and forget — never blocks render)
    try {
      const apiBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
      fetch(`${apiBase}/api/jarvis/frontend-error`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: error?.message || "Unknown error",
          stack: error?.stack?.slice(0, 1000) || "",
          component_stack: errorInfo?.componentStack?.slice(0, 500) || "",
          page: window.location.pathname,
          user_agent: navigator.userAgent.slice(0, 200),
        }),
      }).catch(() => {});
    } catch (_) {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center p-8">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Algo salió mal</h2>
            <p className="text-sm text-gray-500 mb-4">
              {this.state.error?.message || "Error inesperado"}
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              className="px-6 py-2.5 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
